import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { checkboxProps, checkboxEmits } from './checkbox';
import { UPDATE_MODEL_VALUE } from '../../constants';
import createComponentId from '../../utils/createComponentId';


export default /*#__PURE__*/_defineComponent({
  __name: 'checkbox',
  props: checkboxProps,
  emits: checkboxEmits,
  setup(__props, { emit: emits }) {

const props = __props




const inputId = createComponentId('ui-checkbox');

const handleClickCheck = (event: Event): void => {
    const input = event.target as HTMLInputElement;

    // Нативный readonly на чекбоксы не действует — атрибут работает только на
    // текстовых полях, поэтому клик отсекаем сами и возвращаем input в состояние
    // пропа: он скрыт стилями, но остался бы переключённым.
    if (props.disabled || props.readonly) {
        input.checked = Boolean(props.modelValue);
        return;
    }

    const isCheck = input.checked;
    emits(UPDATE_MODEL_VALUE, isCheck);
    emits('change', isCheck);
};

const handleSpaceKey = (): void => {
    if (props.disabled || props.readonly) {
        return;
    }

    const newValue = !props.modelValue;
    emits(UPDATE_MODEL_VALUE, newValue);
    emits('change', newValue);
};

return { __sfc: true,props, emits, inputId, handleClickCheck, handleSpaceKey }
}

})